export default function not(value) {
    return !value;
}
